import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import { Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear, faTrash } from "@fortawesome/free-solid-svg-icons";
import { faFloppyDisk } from "@fortawesome/free-regular-svg-icons";
import Select from "react-select";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { APIMS } from "../../../../../../config/apims";
import { APILA } from "../../../../../../config/apila";
import swal from "sweetalert";
import { PulseLoader } from "react-spinners";

/* ===========================
   CSS
=========================== */
const css = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }
  .shimmer {
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-name: shimmer;
    background: #f6f7f8;
    background: linear-gradient(
      to right,
      #ddeaffff 8%,
      #f4f8ffff 18%,
      #ddeaffff 33%
    );
    background-size: 800px 104px;
  }
  .shimmer-select {
    height: 35px;
    border-radius: 4px;
  }
  .shimmer-row {
    height: 38px;
  }

  // .at-search{ min-width: 280px; }
  // .at-input{
  //   width:100%;
  //   height: 35px;
  //   border:1px solid #280095;
  //   border-radius: 10px;
  //   padding: 0 12px;
  //   font-size: 14px;
  //   outline:none;
  //   background: #fff;
  // }
  // .at-input:focus, .at-select:focus{
  //   border-color:#94a3b8;
  //   box-shadow: 0 0 0 3px rgba(148,163,184,0.25);
  // }

  .at-panel{
    margin-top: 14px;
    background:#fff;
    border:1px solid #e7eaf0;
    overflow: hidden;
  }

  .at-table-wrap{ overflow:auto; }

  .at-table{
    width:100%;
    border-collapse: collapse;
  }

  .at-table thead th{
    text-align:left;
    font-size: 14px;
    color:#3f51b5;
    font-weight: 700;
    padding: 12px 14px;
    border-bottom:1px solid #e9edf5;
    white-space: nowrap;
    background: #fff;
  }

  .at-table tbody td{
    padding: 12px 14px;
    border-bottom:1px solid #edf1f7;
    font-size: 14px;
    color:#0f172a;
    vertical-align: middle;
  }

  .at-center { text-align: center !important; }

  .at-select{
    width:100%;
    height: 40px;
    border:1px solid #cfd8e6;
    border-radius: 0;
    padding: 0 10px;
    font-size: 14px;
    color: #334155;
    background: #fff;
    outline: none;
  }

  .at-select:disabled{
    background: #f8fafc;
    color: #94a3b8;
    cursor: not-allowed;
  }

  .at-select option[disabled]{
    color: #94a3b8;
  }
`;

export default function KonfigurasiRekan() {
  document.title = "Konfigurasi Rekan";
  // const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
  
    const [page] = useState(1);
    const [limit] = useState(1000);
    const [ascending] = useState(1);
    const [descending] = useState(0);
    const [keyword] = useState("");
    const token = localStorage.getItem("token");
    
    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 780px)" });
    const [loading, setLoading] = useState(false);
    const [loadingSchool, setLoadingSchool] = useState(false);

    const firstLoadDone = useRef(false);
    const initSchoolDone = useRef(false);
    const initLevelDone = useRef(false);
    const initKelasDone = useRef(false);

    const storageBranchGroping = localStorage.getItem("ysb_branch_id");
    const storageLevel = localStorage.getItem("level");
    const storageTeacher = localStorage.getItem("ysb_teacher_id") || "";

    const id_user = localStorage.getItem("id_admin") || "";
    const output_id_user = id_user.replace(/[|&;$%@"<>()+,]/g, "");
    
    // Data master
    const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
    const [getDataBranch, setGetDataBranch] = useState([]);
    const [getDataSchool, setGetDataSchool] = useState([]);
    
    // Tingkatan & Kelas
    const [getDataLevel, setGetDataLevel] = useState([]);
    const [getDataKelas, setGetDataKelas] = useState([]);
    const [loadingLevel, setLoadingLevel] = useState(false);
    const [loadingKelas, setLoadingKelas] = useState(false);
    
    
    // Table data
    const [getData, setGetData] = useState([]);

    // Search 
    const [searchKeyword, setSearchKeyword] = useState("");

    // Pagination 
    const [tablePage, setTablePage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // UI state
    const [hasSearched, setHasSearched] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [isFilterDirty, setIsFilterDirty] = useState(false);
    const [selectedTab, setSelectedTab] = useState(null);
    const [isFetching, setIsFetching] = useState(false);

    const [namaTA, setNamaTA] = useState("");
    const [namaSmstr, setNamaSmstr] = useState("");

    const [peerRows, setPeerRows] = useState([]);

    /* modal state */
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const toggleConfirm = () => setIsConfirmOpen((prev) => !prev);
    
    const [isResetConfirmOpen, setIsResetConfirmOpen] = useState(false);
    const toggleResetConfirm = () => setIsResetConfirmOpen(prev => !prev);

    const [saving, setSaving] = useState(false);
    const [resetting, setResetting] = useState(false);

    const [beforeAutoSelectRows, setBeforeAutoSelectRows] = useState(null);
    const [showCancelAutoSelect, setShowCancelAutoSelect] = useState(false);

    //Button Save
    const [showSaveSelectButton, setShowSaveSelectButton] = useState(false);

    // Filter form
    const [form2, setForm2] = useState({
      ysb_semester_id: "",
      ysb_branch_id: "",
      ysb_school_id: "",
      ysb_grade_level_id:"",
      ysb_kelas_id:"",
    });

    // Permission
    const location = useLocation();
    const [permission, setPermission] = useState({
      create: 0,
      read: 0,
      update: 0,
      delete: 0,
    });

    const navigate = useNavigate();
    
    useEffect(() => {
      const level = localStorage.getItem("level");
      const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
      if (level === "developer" || level === "superadmin") {
        setPermission({ create: 1, read: 1, update: 1, delete: 1 });
        return;
      }
      const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
      if (!foundPermission) navigate("/dashboard");
      else {
        setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
        });
      }
    }, [location.pathname, navigate]);
    
    /* API HEADERS */
    const fetchParams = useMemo(
      () => ({
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }), [token]
    );
    
    // ---------- helper refs ----------
    const isMounted = useRef(true);
    const abortControllers = useRef([]);
    
    useEffect(() => {
      return () => {
        isMounted.current = false;
        abortControllers.current.forEach((c) => c.abort());
      };
    }, []);
    
    const collator = useMemo(() => new Intl.Collator("id", { numeric: true, sensitivity: "base" }), []);
      
    const safeStr = (v) => (v === null || v === undefined ? "" : String(v));
    
    // SORT sekolah
    const sortSchools = (schools) => {
      const order = ["SD", "SMP", "SMA"];
      return [...schools].sort((a, b) => {
        const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
        const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
        return jenjangA - jenjangB;
      });
    };

    const removeBasementBekasi = (schools, branchId) => {
      if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
      return schools;
    };

    // =========================
    // INIT: Branch + Semester
    // =========================
    const fetchInit = useCallback(async () => {
      setLoading(true);
      const controller = new AbortController();
      abortControllers.current.push(controller);

      try {
        const [branchRes, semesterRes] = await Promise.all([
          APIMS.get(
            `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
            { ...fetchParams, signal: controller.signal }
          ),
          // APILA.get(
          //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          //   { ...fetchParams, signal: controller.signal }
          // )
          APIMS.get(
            `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
            { ...fetchParams, signal: controller.signal }
          )
        ]);

        if (!isMounted.current) return;

        // Branch default pertama
        if (branchRes?.status === 200) {
          const branches = branchRes.data.data || [];
          setGetDataBranch(branches);
          if (branches.length > 0) {
            const firstBranch = branches[0].branch_code;
            setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
          }
        }

        // Semester aktif
        if (semesterRes?.status === 200) {
          const semesters = semesterRes.data.data || [];
          const active = semesters.find((s) => s.status === 1) || semesters[0];
          setGetDataSemesterMap(semesters);
          if (active) {
            setNamaTA(active.name_year || "");
            setNamaSmstr(active.semester || "");
            setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
          }
        }

      } catch (err) {
        swal({
          title: "Failed",
          text: err?.response?.data?.message || err.message || "Error",
          icon: "error",
        });
      } 

    }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);
      
    useEffect(() => {
      fetchInit();
    }, [fetchInit]);


    const fetchSchoolsByBranch = useCallback(
      async (branchId) => {
        initSchoolDone.current = false;
        initLevelDone.current = false;
        initKelasDone.current = false;
        setLoadingSchool(true); 
        try {
          const res = await APIMS.get(
            `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );
          if (res?.status === 200) {
            let schools = res.data.data || [];

            if (storageLevel === "developer" || storageLevel === "superadmin") {
              schools = schools.filter(
                (s) => s.ysb_branch_id === branchId
              );
            }

            schools = removeBasementBekasi(schools, branchId);
            schools = sortSchools(schools);

            setGetDataSchool(schools);

            if (schools.length > 0) {
              setGetDataLevel([]);
              setGetDataKelas([]);
              setForm2((prev) => ({
                ...prev,
                ysb_school_id: schools[0].school_code,
                ysb_grade_level_id: "",
                ysb_kelas_id: "",
              }));
            } else {
              setGetDataLevel([]);
              setGetDataKelas([]);
              setForm2((prev) => ({ ...prev, ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "" }));
            }
          }
        } catch (err) {
          console.log(err);
        } finally {
            initSchoolDone.current = true;
            setLoadingSchool(false); 
            setLoading(false);      
        }
      },[ascending, fetchParams, limit, page, storageLevel]
    );

    useEffect(() => {
      if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
    }, [form2.ysb_branch_id, fetchSchoolsByBranch]);


    // =========================
    // Fetch tingkatan saat sekolah berubah
    // =========================
    const sortLevels = (levels) => {
      return [...levels].sort((a, b) =>
        (a?.name_level || "").localeCompare((b?.name_level || ""), "id", { numeric: true, sensitivity: "base" })
      );
    };

    const sortKelas = (kelas) => {
      return [...kelas].sort((a, b) =>
        (a?.name_kelas || "").localeCompare((b?.name_kelas || ""), "id", { numeric: true, sensitivity: "base" })
      );
    };

    const fetchLevelsBySchool = useCallback(
      async (schoolId, branchId) => {
        initLevelDone.current = false;
        initKelasDone.current = false; 

        if (!schoolId) return;

        setLoadingLevel(true);
        try {
          const res = await APIMS.get(
            `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );

          if (res?.status === 200) {
            let levels = res.data?.data || [];

            // filter by sekolah + cabang 
            levels = levels.filter((x) => x?.ysb_school_id === schoolId);
            if (branchId) levels = levels.filter((x) => x?.ysb_branch_id === branchId);

            levels = sortLevels(levels);
            setGetDataLevel(levels);

            if (levels.length === 0) {
              initKelasDone.current = true;
            }

            // default tingkatan pertama
            if (levels.length > 0) {
              setForm2((prev) => ({
                ...prev,
                ysb_grade_level_id: levels[0].id,
              }));
            } else {
              setForm2((prev) => ({
                ...prev,
                ysb_grade_level_id: "",
                ysb_kelas_id: "",
              }));

            setGetDataKelas([]);
            }
          }
        } catch (err) {
          console.error(err);
          swal({
            title: "Failed",
            text: err?.response?.data?.message || err.message || "Gagal mengambil data tingkatan",
            icon: "error",
            timer: 3000,
            buttons: false,
          });

          setGetDataLevel([]);
          setGetDataKelas([]);
          setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));

        } finally {
          initLevelDone.current = true;
          setLoadingLevel(false);
        }
      }, [fetchParams]
    );

    useEffect(() => {
      if (!form2.ysb_school_id) {
        setGetDataLevel([]);
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
      return;
      }

      setGetDataLevel([]);
      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
      fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
    }, [form2.ysb_school_id, form2.ysb_branch_id, fetchLevelsBySchool]);

    // =========================
    // Fetch kelas saat tingkatan berubah
    // =========================
    const fetchKelasByLevel = useCallback(
      async (gradeLevelId, schoolId, branchId) => {
        initKelasDone.current = false;

        if (!gradeLevelId) return;

        setLoadingKelas(true);
        try {
          const res = await APIMS.get(
            `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );

          if (res?.status === 200) {
            let kelas = res.data?.data || [];
           
            kelas = kelas.filter((x) => x?.ysb_grade_level_id === gradeLevelId);
            if (schoolId) kelas = kelas.filter((x) => x?.ysb_school_id === schoolId);
            if (branchId) kelas = kelas.filter((x) => x?.ysb_branch_id === branchId);

            kelas = sortKelas(kelas);
            setGetDataKelas(kelas);

            // default kelas pertama
            if (kelas.length > 0) {
              setForm2((prev) => ({
                ...prev,
                ysb_kelas_id: kelas[0].id,
              }));
            } else {
              setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
            }
          }
        } catch (err) {
          console.error(err);
          swal({
            title: "Failed",
            text: err?.response?.data?.message || err.message || "Gagal mengambil data kelas",
            icon: "error",
            timer: 3000,
            buttons: false,
          });
          setGetDataKelas([]);
          setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
        } finally {
          initKelasDone.current = true;
          setLoadingKelas(false);
        }
      }, [fetchParams]
    );

    useEffect(() => {
      if (!form2.ysb_grade_level_id) {
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
        return;
      }

      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
      fetchKelasByLevel(form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id);
    }, [form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id, fetchKelasByLevel]);

  
    // =========================
    // Filter complete
    // =========================
    const isFilterComplete =
      isFilterDirty &&
      !!form2.ysb_semester_id &&
      !!form2.ysb_branch_id &&
      !!form2.ysb_school_id &&
      (!loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id)) &&
      (!loadingKelas && (getDataKelas.length === 0 || !!form2.ysb_kelas_id));

    // =========================
    // Fetch table data
    // =========================
    const GetResponseData = useCallback(async () => {
      if (
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !form2.ysb_school_id 
      ) return;

      setIsFetching(true);
      const params = {
        ysb_semester_id: form2.ysb_semester_id,
        level: storageLevel,
        ysb_branch_id: form2.ysb_branch_id,
        ysb_school_id: form2.ysb_school_id,
      };

      if (form2.ysb_grade_level_id) {
        params.ysb_grade_level_id = form2.ysb_grade_level_id;
      }
      if (form2.ysb_kelas_id) {
        params.ysb_kelas_id = form2.ysb_kelas_id;
      }

      try {
        const response = await APILA.get(
          "/api/config-peers-super/index",
          {
          params,
          ...fetchParams,
          }
        );

      if (response?.status === 200) {
        const rows = response?.data?.students || response?.data?.data || [];
        // const normalized = (rows || []).map((r) => ({
        //   ysb_student_id: r?.ysb_student_id || "",
        //   ysb_student_id2: r?.ysb_student_id2 || "",
        //   siswa_dinilai: r?.siswa_dinilai || "",
        //   siswa_penilai: r?.siswa_penilai || "",
        // }));

         const normalized = (rows || []).map((r) => ({
          ysb_student_id: r?.ysb_student_id || "",
          ysb_student_id2: r?.ysb_student_id2 || "",
          siswa_dinilai: r?.siswa_dinilai || "",
          siswa_penilai: r?.siswa_penilai || "",
          nisn: r?.nisn || "",
          order_absen: r?.order_absen ?? null,
          jenis_kelamin: r?.jenis_kelamin || "",
        }));

        setPeerRows(normalized);
        setGetData(normalized); 
        setBeforeAutoSelectRows(null);
        setShowCancelAutoSelect(false);
        setShowSaveSelectButton(false); 
      }
      } catch (error) {
        swal({
          title: "Gagal",
          text: error?.response?.data?.message || "Gagal mengambil data",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    }, [form2, fetchParams, storageLevel]);

    // AUTO LOAD
    useEffect(() => {
      const schoolReady =
        initSchoolDone.current &&
        !loadingSchool &&
        !!form2.ysb_school_id;

      const gradeReady =
        initLevelDone.current &&
        !loadingLevel &&
        (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);

      const kelasReady =
        initKelasDone.current &&
        !loadingKelas &&
        (getDataKelas.length === 0 || !!form2.ysb_kelas_id);

      if (
        firstLoadDone.current ||
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !schoolReady ||
        !gradeReady ||
        !kelasReady
      ) return;

      firstLoadDone.current = true;

      (async () => {
        setIsFetching(true);
        await GetResponseData(); 
        setHasSearched(true);
        setIsFirstLoad(false);
        setIsFilterDirty(false);
        setIsFetching(false);
      })();
    }, [
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      form2.ysb_grade_level_id,
      form2.ysb_kelas_id,
      loadingSchool,
      loadingLevel,
      loadingKelas,
      getDataLevel.length,
      getDataKelas.length,
    ]);

    // =========================
    // HANDLER perubahan filter 
    // =========================
    const handleChange = (e) => {
      const { name, value } = e.target;

      setForm2((prev) => ({ ...prev, [name]: value }));

      if (!isFirstLoad) {
        setIsFilterDirty(true);
        setHasSearched(false);
      }
    };

    // =========================
    // BUTTON CARI
    // =========================
    const handleCari = async () => {
      if (loadingSchool || loadingLevel || loadingKelas) {
        swal({
          title: "Mohon tunggu",
          text: "Data sekolah/tingkatan/kelas masih dimuat. Coba lagi sebentar.",
          icon: "info",
          timer: 2200,
          buttons: false,
        });
        return;
      }

      const gradeRequired = getDataLevel.length === 0 ? true : !!form2.ysb_grade_level_id;
      const kelasRequired = getDataKelas.length === 0 ? true : !!form2.ysb_kelas_id;

      if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !gradeRequired || !kelasRequired) {
        swal({
          title: "Filter belum lengkap",
          text: "Pastikan Semester, Cabang, Sekolah, Tingkatan,dan Kelas sudah dipilih.",
          icon: "warning",
        });
        return;
      }

      setGetData([]);
      setHasSearched(false);
      setIsFetching(true);
      setSearchKeyword("");

      try {
        await GetResponseData();
        setHasSearched(true);
        setIsFilterDirty(false);
      } catch (err) {
        swal({
          title: "Failed",
          text: err?.response?.data?.message || "Terjadi kesalahan",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    };

      const nameCollator = useMemo(
        () => new Intl.Collator("id", { sensitivity: "base", numeric: true }),
        []
      );
      
      const filteredData = useMemo(() => {
        const q = (searchKeyword || "").trim().toLowerCase();
          
        const base = !q
        ? (getData || [])
        : (getData || []).filter((item) => {
          const name = (item?.nama_siswa || "").toString().toLowerCase();
            const nisn = (item?.nisn || "").toString().toLowerCase();
            return name.includes(q) || nisn.includes(q);
        });
          
        //SORT A -> Z
        return [...base].sort((a, b) =>
          nameCollator.compare(
            (a?.nama_siswa || "").toString().trim(),
            (b?.nama_siswa || "").toString().trim()
          )
        );
      }, [getData, searchKeyword, nameCollator]);
          
      
      const toTitleCase = (value) => {
        const s = safeStr(value).toLowerCase().trim();
        if (!s) return "";
        return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
      };

      const takeSnapshotBeforeAuto = () => {
        
        if (beforeAutoSelectRows && Array.isArray(beforeAutoSelectRows)) {
          setShowCancelAutoSelect(true);
          return;
        }

        const snapshot = (peerRows || []).map((row) => ({ ...row }));
        setBeforeAutoSelectRows(snapshot);
        setShowCancelAutoSelect(true);
      };

      const handleCancelAutoSelect = () => {
        if (!beforeAutoSelectRows || !Array.isArray(beforeAutoSelectRows)) return;

        const restored = beforeAutoSelectRows.map((row) => ({ ...row }));
        setPeerRows(restored);
        setGetData(restored); 

        setBeforeAutoSelectRows(null);
        setShowCancelAutoSelect(false);
        setShowSaveSelectButton(false);
      };
  
      const normalizedSearch = useMemo(
        () => (searchKeyword || "").trim().toLowerCase(),
        [searchKeyword]
      );
    
      const candidateOptions = useMemo(() => {
        const map = new Map();
    
        (peerRows || []).forEach((r) => {
          if (r?.ysb_student_id && r?.siswa_dinilai) {
            map.set(r.ysb_student_id, {
              value: r.ysb_student_id,
              label: toTitleCase(r.siswa_dinilai),
            });
          }

          if (r?.ysb_student_id2 && r?.siswa_penilai) {
            map.set(r.ysb_student_id2, {
              value: r.ysb_student_id2,
              label: toTitleCase(r.siswa_penilai),
            });
          }
        });
    
        return Array.from(map.values()).sort((a, b) =>
          a.label.localeCompare(b.label, "id", { sensitivity: "base" })
        );
      }, [peerRows]);
    
      const optionById = useMemo(() => {
        const obj = {};
        candidateOptions.forEach((o) => {
          obj[o.value] = o;
        });
        return obj;
      }, [candidateOptions]);
    
      // const filteredRows = useMemo(() => {
      //   if (!normalizedSearch) return peerRows;
    
      //   return (peerRows || []).filter((r) => {
      //     const dinilai = (r?.siswa_dinilai || "").toLowerCase();
      //     const penilai = (r?.siswa_penilai || "").toLowerCase();
      //     return dinilai.includes(normalizedSearch) || penilai.includes(normalizedSearch);
      //   });
      // }, [peerRows, normalizedSearch]);

        const filteredRows = useMemo(() => {
        let rows = Array.isArray(peerRows) ? [...peerRows] : [];
      
        if (normalizedSearch) {
          rows = rows.filter((r) => {
            const dinilai = safeStr(r?.siswa_dinilai).toLowerCase();
            const penilai = safeStr(r?.siswa_penilai).toLowerCase();
            const nisn = safeStr(r?.nisn).toLowerCase();
      
            return (
              dinilai.includes(normalizedSearch) ||
              penilai.includes(normalizedSearch) ||
              nisn.includes(normalizedSearch)
            );
          });
        }
      
        // SORT:
        // 1. Siswa lama: order_absen null/kosong => tetap A-Z
        // 2. Siswa baru: order_absen ada nilainya => taruh paling bawah
        // 3. Siswa baru diurutkan berdasarkan order_absen ASC
        rows.sort((a, b) => {
          const orderA =
            a?.order_absen === null ||
            a?.order_absen === undefined ||
            a?.order_absen === ""
              ? null
              : Number(a.order_absen);
      
          const orderB =
            b?.order_absen === null ||
            b?.order_absen === undefined ||
            b?.order_absen === ""
              ? null
              : Number(b.order_absen);
      
          const aIsNew = orderA !== null && !Number.isNaN(orderA);
          const bIsNew = orderB !== null && !Number.isNaN(orderB);
      
          // siswa lama tetap di atas
          if (!aIsNew && bIsNew) return -1;
      
          // siswa baru taruh di bawah
          if (aIsNew && !bIsNew) return 1;
      
          // sama-sama siswa baru => urut berdasarkan order_absen
          if (aIsNew && bIsNew) {
            if (orderA !== orderB) return orderA - orderB;
      
            const nameCompare = collator.compare(
              safeStr(a?.siswa_dinilai),
              safeStr(b?.siswa_dinilai)
            );
      
            if (nameCompare !== 0) return nameCompare;
      
            return collator.compare(
              safeStr(a?.nisn),
              safeStr(b?.nisn)
            );
          }
      
          // sama-sama siswa lama => tetap A-Z
          const nameCompare = collator.compare(
            safeStr(a?.siswa_dinilai),
            safeStr(b?.siswa_dinilai)
          );
      
          if (nameCompare !== 0) return nameCompare;
      
          return collator.compare(
            safeStr(a?.nisn),
            safeStr(b?.nisn)
          );
        });
      
        return rows;
      }, [peerRows, normalizedSearch, collator]);
    
      const usedPenilaiIds = useMemo(() => {
        return (peerRows || []).map((r) => r?.ysb_student_id2).filter(Boolean);
      }, [peerRows]);
    
      const makeRowKey = (r, idx) => `${r?.ysb_student_id || "noid"}-${idx}`;
    
      const handleChangePenilai = (rowKey, selectedOption) => {
        takeSnapshotBeforeAuto();

        const selectedId = selectedOption?.value || "";
        const selectedName = selectedOption?.label || "";

        setPeerRows((prev) =>
          prev.map((r, idx) => {
            const key = makeRowKey(r, idx);
            if (key !== rowKey) return r;
            return {
              ...r,
              ysb_student_id2: selectedId,
              siswa_penilai: selectedName,
            };
          })
        );

        setShowSaveSelectButton(true);
        setShowCancelAutoSelect(true);
      };

      const handleRemovePenilai = (rowKey) => {
        takeSnapshotBeforeAuto();

        setPeerRows((prev) =>
          prev.map((r, idx) => {
            const key = makeRowKey(r, idx);
            if (key !== rowKey) return r;
            return {
              ...r,
              ysb_student_id2: "",
              siswa_penilai: "",
            };
          })
        );

        setShowSaveSelectButton(true);
        setShowCancelAutoSelect(true);
      };


      const handleAutoSelect = () => {
        takeSnapshotBeforeAuto();

        setPeerRows(prev => {
          if (!prev || prev.length === 0) return prev;
    
          const rows = prev.map(r => ({ ...r }));
    
          const ids = rows.map(r => r.ysb_student_id);
   
          const shuffle = arr => {
            const a = [...arr];
            for (let i = a.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [a[i], a[j]] = [a[j], a[i]];
            }
            return a;
          };
    
          let shuffled;
          let valid = false;
          let attempts = 0;
    
          while (!valid && attempts < 50) {
            shuffled = shuffle(ids);
            valid = shuffled.every((id, i) => id !== ids[i]);
            attempts++;
          }
    
          rows.forEach((row, i) => {
            const penilaiId = shuffled[i];
            row.ysb_student_id2 = penilaiId;
            row.siswa_penilai =
              optionById[penilaiId]?.label || "";
          });
    
          return rows;

          
        });

        setShowSaveSelectButton(true);
      };

      const handleAutoGender = () => {
        takeSnapshotBeforeAuto();

        setPeerRows((prev) => {
          if (!prev || prev.length === 0) return prev;

          const rows = prev.map((r) => ({ ...r }));

          const getGenderKey = (jk) => {
            if (!jk) return "OTHER";
            const s = String(jk).trim().toUpperCase();
            if (s === "L" || s === "LAKI-LAKI") return "L";
            if (s === "P" || s === "PEREMPUAN") return "P";
            return s;
          };

          const groups = {};
          rows.forEach((row, idx) => {
            const gKey = getGenderKey(row.jenis_kelamin);
            if (!groups[gKey]) groups[gKey] = [];
            groups[gKey].push({ row, idx });
          });

          const shuffleGroup = (ids) => {
            if (ids.length <= 1) return [...ids];
            const a = [...ids];
            let attempts = 0;
            let valid = false;
            while (!valid && attempts < 50) {
              for (let i = a.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [a[i], a[j]] = [a[j], a[i]];
              }
              valid = a.every((id, index) => id !== ids[index]);
              attempts++;
            }
            if (!valid && ids.length > 1) {
              for (let i = 0; i < ids.length; i++) {
                a[i] = ids[(i + 1) % ids.length];
              }
            }
            return a;
          };

          Object.keys(groups).forEach((gKey) => {
            const groupItems = groups[gKey];
            const ids = groupItems.map((item) => item.row.ysb_student_id);
            const shuffledIds = shuffleGroup(ids);

            groupItems.forEach((item, i) => {
              const penilaiId = shuffledIds[i];
              item.row.ysb_student_id2 = penilaiId;
              item.row.siswa_penilai = optionById[penilaiId]?.label || "";
            });
          });

          return rows;
        });

        setShowSaveSelectButton(true);
      };
    
      const handleClickReset = () => {
        toggleResetConfirm();
      };

      const validateAssignmentParams = () => {
        if (!form2?.ysb_semester_id || !form2?.ysb_branch_id || !form2?.ysb_school_id) {
          swal({ title: "Filter belum lengkap", text: "Pastikan Semester, Cabang, dan Sekolah sudah dipilih.", icon: "warning" });
          return false;
        }

        if (getDataLevel.length > 0 && !form2?.ysb_grade_level_id) {
          swal({ title: "Filter belum lengkap", text: "Pilih Tingkatan terlebih dahulu.", icon: "warning" });
          return false;
        }
        if (getDataKelas.length > 0 && !form2?.ysb_kelas_id) {
          swal({ title: "Filter belum lengkap", text: "Pilih Kelas terlebih dahulu.", icon: "warning" });
          return false;
        }

        return true;
      };

      const buildStorePayload = (rows, { resetAll = false } = {}) => {
        return {
          ysb_branch_id: form2?.ysb_branch_id,
          ysb_school_id: form2?.ysb_school_id,
          ysb_semester_id: form2?.ysb_semester_id,

          ysb_teacher_id: storageTeacher,

          ysb_grade_level_id: form2?.ysb_grade_level_id || "",
          ysb_kelas_id: form2?.ysb_kelas_id || "",

          students: (rows || []).map((r) => ({
            ysb_student_id: r?.ysb_student_id,
            ysb_student_id2: resetAll ? "" : (r?.ysb_student_id2 || ""),
          })),

          user_id: output_id_user,
        };
      };

    
    const handleConfirmReset = async () => {
      if (!validateAssignmentParams()) return;

      setResetting(true);
      try {
        const payload = buildStorePayload(peerRows, { resetAll: true });

        await APILA.post(
          "/api/config-peers-super/store",  
          payload,
          fetchParams
        );

       
        const clearedRows = (peerRows || []).map((r) => ({
          ...r,
          ysb_student_id2: "",
          siswa_penilai: "",
        }));
        setPeerRows(clearedRows);

        swal({
          title: "Berhasil",
          text: "Semua penilai berhasil di-reset.",
          icon: "success",
        });

        toggleResetConfirm();
        await GetResponseData();
      } catch (error) {
        swal({
          title: "Gagal",
          text: error?.response?.data?.message || "Reset gagal.",
          icon: "error",
        });
      } finally {
        setResetting(false);
      }
    };
    
      const handleClickSave = () => {
        setIsConfirmOpen(true);
      };
    
      const handleConfirmSave = async () => {
        if (!validateAssignmentParams()) return;

        setSaving(true);
        try {
          const payload = buildStorePayload(peerRows, { resetAll: false });

          const response = await APILA.post(
            "/api/config-peers-super/store", 
            payload,
            fetchParams
          );

          swal({
            title: "Berhasil",
            text: response?.data?.message || "Data berhasil disimpan",
            icon: "success",
          });

          setIsConfirmOpen(false);
          setShowSaveSelectButton(false);
          await GetResponseData();
        } catch (error) {
          console.log("SAVE ERROR STATUS:", error?.response?.status);
          console.log("SAVE ERROR DATA:", error?.response?.data);

          swal({
            title: "Gagal",
            text: error?.response?.data?.message || "Gagal menyimpan data.",
            icon: "error",
          });
        } finally {
          setSaving(false);
        }
      };


  return (
    <div className="body">
      <style>{css}</style>

      <div className="page-header-card">
         {isTabletOrMobile ? (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faGear} />
                  </span>
                <h4 className="page-title-text">  Konfigurasi Rekan Sejawat</h4>
              </div>
            </div>

             <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-la-main">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li className="custom-breadcrumb-item">
                  <Link style={{ textDecoration: "none" }} to="/konfigurasi-angket">
                      Konfigurasi Angket
                    </Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                   Konfigurasi Rekan Sejawat
                </li>
              </ol>
            </nav>
          </>
          ) : (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faGear} />
                </span>
                <h4 className="page-title-text">  Konfigurasi Rekan Sejawat</h4>
              </div>
            </div>

            <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-la-main">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li className="custom-breadcrumb-item">
                  <Link style={{ textDecoration: "none" }} to="/konfigurasi-angket">
                      Konfigurasi Angket
                    </Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                   Konfigurasi Rekan Sejawat
                </li>
              </ol>
            </nav>
          </>
         )}
      </div>

      <div className="body-content">

          {/* FILTER */}
          {isTabletOrMobile ? (
            <div className="title-page">
              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="mr-2"
                  name="ysb_semester_id"
                  value={form2.ysb_semester_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    {namaTA} (Semester {namaSmstr})
                  </option>
                  {getDataSemesterMap.map((user, index) => (
                    <option key={index} value={user?.id}>
                      {user?.name_year} (Semester {user?.semester})
                    </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="mr-2"
                  name="ysb_branch_id"
                  value={form2.ysb_branch_id}
                  onChange={handleChange}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    background: "#fff",
                  }}
                >
                  <option value="" hidden>
                    Pilih Cabang
                  </option>
                  {getDataBranch.map((user, index) => (
                    <option key={index} value={user?.branch_code}>
                      {user?.branch_name}
                    </option>
                  ))}
                </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
               <select
                          className="mr-2"
                          name="ysb_school_id"
                          value={form2.ysb_school_id}
                          onChange={handleChange}
                          disabled={loadingSchool}
                          style={{
                           border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                            cursor: loadingSchool ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden> 
                            {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                          </option>

                          {!loadingSchool &&
                            getDataSchool.map((user, index) => (
                              <option key={index} value={user?.school_code}>
                                {user?.school_name}
                              </option>
                            ))}
                        </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="mr-2"
                  name="ysb_grade_level_id"
                  value={form2.ysb_grade_level_id}
                  onChange={handleChange}
                  disabled={loadingLevel}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    backgroundColor: loadingLevel ? "#f5f5f5" : "#fff",
                    cursor: loadingLevel ? "not-allowed" : "pointer",
                  }}
                >
                  <option value="" hidden>
                    {loadingLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                  </option>
                  {!loadingLevel &&
                    getDataLevel.map((user, index) => (
                      <option key={index} value={user?.id}>
                        {user?.name_level}
                      </option>
                    ))}
                </select>
              </Row>

              <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                <select
                  className="mr-2"
                  name="ysb_kelas_id"
                  value={form2.ysb_kelas_id}
                  onChange={handleChange}
                  disabled={loadingKelas}
                  style={{
                    border: "1px solid #d9defa",
                    borderRadius: "12px",
                    fontSize: "14px",
                    padding: "10px 12px",
                    backgroundColor: loadingKelas ? "#f5f5f5" : "#fff",
                    cursor: loadingKelas ? "not-allowed" : "pointer",
                  }}
                >
                  <option value="" hidden>
                    {loadingKelas ? "Memuat data kelas..." : "Pilih Kelas"}
                  </option>
                  {!loadingKelas &&
                    getDataKelas.map((user, index) => (
                      <option key={index} value={user?.id}>
                        {user?.name_kelas}
                      </option>
                    ))}
                </select>
              </Row>

              <Row style={{ marginTop: "12px", padding: "0 12px" }}>
                <button
                  onClick={handleCari}
                  disabled={!isFilterComplete}
                  className="btn"
                  style={{
                    fontSize: "13px",
                    padding: "10px 16px",
                    borderRadius: "12px",
                    backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                    color: "#fff",
                    cursor: !isFilterComplete ? "not-allowed" : "pointer",
                  }}
                >
                  Cari
                </button>
              </Row>
            </div>
          ) : (
            <>
              <div className="mb-3">
                {loading ? (
                  <>
                    <div className="mb-3 d-flex">
                      <div className="shimmer shimmer-select mr-2" style={{width:180, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:220, borderRadius: "12px"}} />
                    </div>
                    
                    <div className="d-flex">
                      <div className="shimmer shimmer-select mr-2" style={{width:140, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:140, borderRadius: "12px"}} />
                      <div className="shimmer shimmer-select mr-2" style={{width:60, borderRadius: "12px"}} />
                    </div>
                  </>
                ) : (
                    <div className="mb-3 mt-1">
                      <div className="d-flex">
                        <select
                          className="mr-2"
                          name="ysb_semester_id"
                          value={form2.ysb_semester_id}
                          onChange={handleChange}
                          style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                        >
                          <option value="" hidden>
                            {namaTA} (Semester {namaSmstr})
                          </option>
                          {getDataSemesterMap.map((user, index) => (
                            <option key={index} value={user?.id}>
                              {user?.name_year} (Semester {user?.semester})
                            </option>
                          ))}
                        </select>

                        <select
                          className="mr-2"
                          name="ysb_branch_id"
                          value={form2.ysb_branch_id}
                          onChange={handleChange}
                          style={{
                              border: "1px solid #d9defa",
                              borderRadius: "12px",
                              fontSize: "14px",
                              padding: "10px 12px",
                              background: "#fff",
                            }}
                        >
                          <option value="" hidden>
                            Pilih Cabang
                          </option>
                          {getDataBranch.map((user, index) => (
                            <option key={index} value={user?.branch_code}>
                              {user?.branch_name}
                            </option>
                          ))}
                        </select>

                        <select
                          className="mr-2"
                          name="ysb_school_id"
                          value={form2.ysb_school_id}
                          onChange={handleChange}
                          disabled={loadingSchool}
                          style={{
                           border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            backgroundColor: loadingSchool ? "#f5f5f5" : "#fff",
                            cursor: loadingSchool ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden> 
                            {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                          </option>

                          {!loadingSchool &&
                            getDataSchool.map((user, index) => (
                              <option key={index} value={user?.school_code}>
                                {user?.school_name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="mt-3 d-flex">
                         <select
                          className="mr-2"
                          name="ysb_grade_level_id"
                          value={form2.ysb_grade_level_id}
                          onChange={handleChange}
                          disabled={loadingLevel}
                          style={{
                            border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            backgroundColor: loadingLevel ? "#f5f5f5" : "#fff",
                            cursor: loadingLevel ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                          </option>

                          {!loadingLevel &&
                            getDataLevel.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_level}
                              </option>
                            ))}
                        </select>

                        <select
                          className="mr-2"
                          name="ysb_kelas_id"
                          value={form2.ysb_kelas_id}
                          onChange={handleChange}
                          disabled={loadingKelas}
                          style={{
                           border: "1px solid #d9defa",
                            borderRadius: "12px",
                            fontSize: "14px",
                            padding: "10px 12px",
                            backgroundColor: loadingKelas ? "#f5f5f5" : "#fff",
                            cursor: loadingKelas ? "not-allowed" : "pointer",
                          }}
                        >
                          <option value="" hidden>
                            {loadingKelas ? "Memuat data kelas..." : "Pilih Kelas"}
                          </option>

                          {!loadingKelas &&
                            getDataKelas.map((user, index) => (
                              <option key={index} value={user?.id}>
                                {user?.name_kelas}
                              </option>
                            ))}
                        </select>

                        <button
                          onClick={handleCari}
                          disabled={!isFilterComplete}
                          className="btn"
                          style={{
                            fontSize: "13px",
                            padding: "10px 16px",
                            borderRadius: "12px",
                            backgroundColor: !isFilterComplete ? "#c9c9c9" : "#eca91aff",
                            color: "#fff",
                            cursor: !isFilterComplete ? "not-allowed" : "pointer",
                            
                          }}
                        >
                          Cari
                        </button>
                       
                        
                        

                      </div>
                    </div>
                )
              }
              </div>
              
            </>           
          )}

        {isFetching && (
          <div className="text-center" style={{ padding: "10px 0" }}>
            <PulseLoader color={"#3f5bea"} size={12} />
          </div>
        )}

        {hasSearched && !isFetching && (
              <>
                {isTabletOrMobile ? (
                  <div className="title-page mt-4">
                     <hr/>
                    <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                      <input
                        className="at-input"
                        placeholder="Cari Siswa / NISN"
                        value={searchKeyword}
                        onChange={(e) => setSearchKeyword(e.target.value)}
                      />
                    </Row>
                    <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                      <button
                        className="btn  btn-create"
                        onClick={handleClickReset}
                        style={{backgroundColor: "#dc2626"}}
                      >
                        Reset
                      </button>
                    </Row>
                    <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                      <button 
                        className="btn btn-create" 
                        onClick={handleAutoGender}
                        style={{ width: "100%",  }}>
                        Auto Gender
                      </button>
                    </Row>
                    <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                      <button 
                        className="btn btn-create" 
                        onClick={handleAutoSelect}
                        style={{  width: "100%" }}>
                        Auto Select
                      </button>
                    </Row>

                    {showSaveSelectButton && (
                      <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                          <button
                            className="btn btn-create"
                            onClick={handleClickSave}
                            style={{
                              width: "100%",
                              display: "block",
                            }}
                          >
                            Simpan
                          </button>
                      </Row>
                    )}

                    {showCancelAutoSelect && (
                      <Row style={{ marginTop: "10px", padding: "0 12px" }}>
                        <button
                              className="btn"
                              onClick={handleCancelAutoSelect}
                              title="Batalkan auto select"
                              style={{
                                width: "100%",
                                display: "block",
                                border: "1px solid #f1b5b5",
                                backgroundColor: "#fff5f5",
                                fontSize: "13px"
                              }}
                            >
                              Batal
                        </button>
                      </Row>
                    )}

                  </div>
                ) : (
                  <>
                    <div className="mt-4 d-flex">
                      <div className="at-search">
                        <input
                            className="at-input"
                            placeholder="Cari Siswa / NISN"
                            value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                        />
                      </div>
                      <div className="ml-auto">
                        <button
                          className="btn btn-create mr-2"
                          onClick={handleAutoGender}
                          
                        >
                          Auto Gender
                        </button>
                        <button className="btn btn-create" onClick={handleAutoSelect}>
                          Auto Select
                        </button>
                        <button
                          className="btn btn-create ml-2"
                          onClick={handleClickReset}
                          style={{backgroundColor: "#dc2626"}}
                        >
                          Reset
                        </button>
                      </div>
                    </div>

                    {showSaveSelectButton && (
                      <div className="mt-2">
                        <button
                          className="btn btn-create"
                          onClick={handleClickSave}
                          style={{
                            width: "100%",
                            display: "block",
                            padding: "7px 5px",
                            fontSize: "14px",
                            marginTop: "16px"
                          }}
                        >
                          Simpan
                        </button>
                      </div>
                    )}
                    {showCancelAutoSelect && (
                      <div className="mt-2">
                        <button
                            className="btn mr-2"
                            onClick={handleCancelAutoSelect}
                            title="Batalkan auto select"
                            style={{
                              border: "1px solid #f1b5b5",
                              backgroundColor: "#fff5f5",
                              width: "100%",
                              display: "block",
                              padding: "6px 5px",
                              fontSize: "14px",
                              marginTop: "10px"
                            }}
                          >
                            Batal
                          </button>
                      </div>
                    )}
                  </>
                
                )}
               
    
                <Col xl="12" sm="12" className="mb-4">
                  <div className="mt-1 mb-4 body-table">
                    <div className="at-panel">
                      <div className="at-table-wrap">
                        <table className="at-table ">
                         
                          <thead>
                            <tr>
                              <th style={{ width: 90 }} className="at-center">No</th>
                              <th>Nama Siswa</th>
                              <th className="at-center">Siswa yang Menilai</th>
                              <th className="at-center" style={{ width: 90 }}>Hapus</th>
                            </tr>
                          </thead>

                          <tbody>
                            {filteredRows.length === 0 ? (
                              <tr>
                                <td colSpan={4} className="at-center" style={{ padding: "20px" }}>
                                  Data tidak ditemukan.
                                </td>
                              </tr>
                            ) : (
                            filteredRows.map((row, index) => {
                            const globalRowIndex = peerRows.findIndex((r, idx) => {
                              return makeRowKey(r, idx) === makeRowKey(row, index);
                            });
                            const rowKey =
                              globalRowIndex >= 0 ? makeRowKey(peerRows[globalRowIndex], globalRowIndex) : makeRowKey(row, index);

                            const selectedId = row?.ysb_student_id2 || "";
                            const selectedOption = selectedId ? optionById[selectedId] || null : null;

                            return (
                              <tr key={rowKey}>
                                <td className="at-center">{index + 1}</td>
                                <td>{toTitleCase(row?.siswa_dinilai || "-")}</td>
                                <td>
                                  <Select
                                    classNamePrefix="react-select"
                                    placeholder="Pilih penilai..."
                                    isClearable
                                    options={candidateOptions.map((opt) => {
                                      const usedByOtherRow =
                                        usedPenilaiIds.includes(opt.value) && opt.value !== selectedId;
                                      const selfAsEvaluator = opt.value === row?.ysb_student_id;

                                      return {
                                        ...opt,
                                        isDisabled: usedByOtherRow || selfAsEvaluator,
                                      };
                                    })}
                                    value={selectedOption}
                                    onChange={(val) => handleChangePenilai(rowKey, val)}
                                    filterOption={(candidate, input) =>
                                      candidate.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                  />
                                </td>
                                <td className="at-center">
                                  <button
                                    type="button"
                                    className="btn btn-sm"
                                    onClick={() => handleRemovePenilai(rowKey)}
                                    title="Hapus penilai"
                                    style={{
                                      border: "1px solid #ef4444",
                                      color: "#ef4444",
                                      background: "#fff",
                                      borderRadius: 6,
                                      width: 34,
                                      height: 34,
                                      padding: 0,
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            );
                          })

                            )}
                          </tbody>


                        </table>
                      </div>
                    </div>
                  </div>
                </Col>
    
              </>
            )}
          </div>

          <Modal
            isOpen={isConfirmOpen}
            toggle={toggleConfirm}
            centered
          >
            <ModalHeader toggle={toggleConfirm}>
              <span style={{ fontWeight: 600, fontSize: 18 }}>
                <FontAwesomeIcon icon={faFloppyDisk} /> Konfirmasi Simpan Penilai
              </span>
            </ModalHeader>

            <ModalBody>

              <div
                style={{
                  background: "#eff6ff",
                  border: "1px solid #bfdbfe",
                  borderRadius: 8,
                  padding: 14,
                  marginBottom: 12,
                  color: "#1e3a8a",
                  fontSize: 14,
                  lineHeight: 1.6,
                  marginTop: 20
                }}
              >
                
                 Konfigurasi penilai yang telah dipilih akan
                <b> disimpan. </b>
              </div>
              <span style={{ fontSize: 14, marginLeft: 5}}>
                Apakah Anda yakin ingin menyimpan perubahan ini?
              </span>

            </ModalBody>

            <ModalFooter
              style={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                color="secondary"
                onClick={toggleConfirm}
                style={{ 
                  fontSize: 13,
                  cursor: "pointer",
                 }}
                
              >
                Batal
              </Button>

              <Button
                onClick={handleConfirmSave}
                disabled={saving}
                style={{ backgroundColor: "#3f5bea", color: "#fff", fontSize: 13, cursor: "pointer" }}
              >
                {saving ? "Menyimpan..." : "Ya, Simpan"}
              </Button>

            </ModalFooter>
          </Modal>


          <Modal
            isOpen={isResetConfirmOpen}
            toggle={toggleResetConfirm}
            centered
          >
            <ModalHeader toggle={toggleResetConfirm}>
              <span style={{ color: "#dc2626", fontWeight: 600, fontSize: 18 }}>
                ⚠ Reset Penilai
              </span>
            </ModalHeader>

            <ModalBody>

              <div
                style={{
                  background: "#fef2f2",
                  border: "1px solid #fecaca",
                  borderRadius: 8,
                  padding: 14,
                  marginBottom: 12,
                  color: "#7f1d1d",
                  fontSize: 14,
                  lineHeight: 1.6,
                  marginTop: 20
                }}
              >
                Jika di-reset, <b>seluruh data penilai akan dihapus</b> dari konfigurasi.
              </div>

              <span style={{ fontSize: 14, marginLeft: 5}}>
                Apakah Anda yakin ingin melanjutkan?
              </span>

            </ModalBody>

            <ModalFooter
              style={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >

              <Button
                color="secondary"
                onClick={toggleResetConfirm}
                style={{ 
                  fontSize: 13,
                  cursor: "pointer",
                 }}
                
              >
                Batal
              </Button>

              <Button
                onClick={handleConfirmReset}
                disabled={resetting}
                style={{ backgroundColor: "#dc2626", color: "#fff", fontSize: 13, cursor: "pointer", border: "none" }}
              >
                {resetting ? "Mereset..." : "Ya, Reset"}
              </Button>

            </ModalFooter>
          </Modal>
    </div>
  );
}